import { useState } from "react";
import Skeleton from "react-loading-skeleton";
import FormError from "./FormError";

const TextArea = ({ value, onChange, loading, label, alert, placeholder, name, id, required, rows, maxLength, ref }) => {

    const [length, setLength] = useState(String(value).length);

    return (
        <>
            {label && <label className="mb-2.5 text-black flex justify-between text-xs dark:text-white font-medium">
                <span>{label} {required && <span className="text-red-500">*</span>}</span>
                {maxLength && <span className={`${length == maxLength && "text-red"}`}>{`${length} / ${maxLength}`}</span>}
            </label>}
            <div className='relative'>
                {/* <Skeleton className={`${loading ? "!block" : "!hidden"} !absolute w-full h-full`} /> */}
                <textarea
                    onChange={
                        (e) => {
                            if (maxLength) {
                                if (e.target.value.length <= Number(maxLength)) {
                                    setLength(e.target.value.length)
                                    onChange(e)
                                }
                            } else {
                                onChange && onChange(e)
                            }
                        }
                    }
                    id={id ? id : ""}
                    ref={ref ? ref : null}
                    name={name}
                    value={value}
                    rows={rows ? rows : 6}
                    placeholder={placeholder ? placeholder : ""}
                    className={`${loading ? "invisible" : "visible"} w-full rounded-lg border-stroke bg-transparent py-3 px-5 text-black outline-none transition`}
                />
            </div>
            {alert && <FormError errors={alert} name={name} />}
        </>
    );
};

export default TextArea;